import React from 'react';

/* Pictogrammes d'une offre : tracés monochromes (currentColor), aucune couleur
   en dur. Une offre en choisit un ; sans choix, celui de son équation. */
const P = {
  briefcase: 'M3 8h18v11H3zM8 8V5h8v3M3 13h18',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2',
  package: 'M12 3l9 4.5v9L12 21l-9-4.5v-9zM12 12l9-4.5M12 12L3 7.5M12 12v9',
  repeat: 'M17 3l4 4-4 4M21 7H8a4 4 0 0 0-4 4M7 21l-4-4 4-4M3 17h13a4 4 0 0 0 4-4',
  watch: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM9 7l1-4h4l1 4M9 17l1 4h4l1-4M12 10v2l1.5 1',
  box: 'M4 7h16v13H4zM4 7l2-4h12l2 4M10 11h4',
  tag: 'M3 12V4h8l10 10-8 8zM7 8h.01',
  percent: 'M19 5L5 19M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  building: 'M4 21V5l8-3v19M12 21V9l8 3v9M8 8h1M8 12h1M8 16h1M16 15h1M16 18h1M2 21h20',
  truck: 'M3 6h11v10H3zM14 10h4l3 3v3h-7zM7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  wrench: 'M14 4a5 5 0 0 0 6 6l-9 9a2 2 0 0 1-3-3l9-9zM4 20l1-1',
  flag: 'M5 21V4h13l-2 4 2 4H5',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2 21a7 7 0 0 1 14 0M16 4a3.5 3.5 0 0 1 0 7M22 21a7 7 0 0 0-5-6.7',
  user: 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
  hourbook: 'M5 4h10l4 4v12H5zM15 4v4h4M8 12h8M8 16h5M17.5 16a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM17.5 17.5V19l1 .7',
  school: 'M2 9l10-5 10 5-10 5zM6 11.5V17c0 1.5 3 3 6 3s6-1.5 6-3v-5.5M22 9v6',
  server: 'M4 4h16v6H4zM4 14h16v6H4zM7 7h.01M7 17h.01M11 7h4M11 17h4',
  desk: 'M2 9h20M4 9v10M20 9v10M4 14h16M9 9V5h6v4',
  fill: 'M6 3h12v18H6zM6 12c2-1.5 4-1.5 6 0s4 1.5 6 0M6 16c2-1.5 4-1.5 6 0s4 1.5 6 0M6 20c2-1.5 4-1.5 6 0s4 1.5 6 0',
};
/* PROFONDEUR (essai 2026-09-08) : sous le trait, une forme PLEINE à 14 % de la
   couleur du trait. Deux tons de la même teinte, donc rien de nouveau dans la
   charte et rien à refaire par thème ; ni ombre, ni dégradé. Un pictogramme sans
   forme fermée (des flèches, un trait) n'en reçoit pas. */
const F = {
  briefcase: 'M3 8h18v11H3z',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
  package: 'M12 3l9 4.5v9L12 21l-9-4.5v-9z',
  watch: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z',
  box: 'M4 7h16v13H4z',
  tag: 'M3 12V4h8l10 10-8 8z',
  percent: 'M7.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16.5 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  building: 'M4 21V5l8-3v19z',
  truck: 'M3 6h11v10H3z',
  wrench: 'M14 4a5 5 0 0 0 6 6l-9 9a2 2 0 0 1-3-3l9-9z',
  flag: 'M5 21V4h13l-2 4 2 4H5z',
  star: 'M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z',
  user: 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  hourbook: 'M5 4h10l4 4v12H5z',
  school: 'M2 9l10-5 10 5-10 5z',
  server: 'M4 4h16v6H4zM4 14h16v6H4z',
  desk: 'M9 5h6v4H9z',
  fill: 'M6 12c2-1.5 4-1.5 6 0s4 1.5 6 0V21H6z',
};
export const ICONS = Object.keys(P);
/* Les MODÈLES (2026-09-04) : un archétype = un pictogramme + un pré-remplissage
   (posé par le serveur). L'ordre est celui de la liste du détail. */
export const MODELS = [   // le produit d'abord, puis les services par ordre alphabétique, « autre » en dernier
  { id: 'produit', icon: 'package', fam: 'product' }, { id: 'volume', icon: 'fill', fam: 'product' },
  { id: 'conseil', icon: 'users', fam: 'labour' }, { id: 'carnet', icon: 'hourbook', fam: 'labour' },
  { id: 'formation', icon: 'school', fam: 'labour' }, { id: 'transport', icon: 'truck', fam: 'labour' },
  { id: 'forfait', icon: 'briefcase', fam: 'labour' }, { id: 'projet', icon: 'flag', fam: 'labour' },
  { id: 'services_manages', icon: 'server', fam: 'labour' },
  { id: 'abonnement', icon: 'repeat', fam: 'service' }, { id: 'licence', icon: 'tag', fam: 'service' },
  { id: 'location', icon: 'clock', fam: 'service' }, { id: 'espace', icon: 'desk', fam: 'service' },
  { id: 'commission', icon: 'percent', fam: 'service' },
  { id: 'autre', icon: 'star', fam: 'service' },   // ne fige rien ; réservé aux services pour l'instant
];
/* Les modèles proposés dans une nature (2026-09-08) : l'onglet Produits n'en montre
   qu'un, « Produit physique », au lieu des douze de la liste complète ; « Autre » reste
   aux services le temps que les produits se tiennent de bout en bout. Le modèle
   déjà posé sur une offre figure toujours dans sa liste, jamais masqué en silence. */
/* `actifs` : la sélection du client (2026-09-10), un ensemble de clés ; vide ou
   absente, tout le catalogue est proposé. Le modèle DÉJÀ POSÉ sur l'offre reste
   dans sa liste, même décoché : on ne masque jamais en silence ce qui est en
   place. */
export const modelesDe = (fam, courant = null, actifs = null) =>
  MODELS.filter((m) => (m.fam === fam && (!actifs || actifs.has(m.id))) || m.id === courant);
export const libelleModel = (p, id) => ({
  produit: p('Produit physique'), volume: p('Volume mesuré'),
  conseil: p('Conseil, régie'), carnet: p("Carnet d'heures"), formation: p('Formation'),
  forfait: p('Service forfaitaire'), projet: p('Projet, mandat forfaitaire'),
  services_manages: p('Services managés, maintenance'), transport: p('Transport, livraison'),
  abonnement: p("Abonnement d'accès"), licence: p("Licence, droit d'exploitation"),
  location: p('Location de matériel'), espace: p('Espace, place, chambre'),
  commission: p('Commission'), autre: p('Modèle personnalisé'),
}[id] || id);
/* Le PRODUIT qu'on livre, la PRESTATION qui coûte du temps d'homme, le SERVICE
   qui tourne sans main-d'œuvre dédiée. */
export const libelleNature = (p, fam, pluriel = false) => (
  { product: pluriel ? p('Marchandises') : p('Marchandise'),
    labour: pluriel ? p('Prestations') : p('Prestation'),
    service: pluriel ? p('Droits & usages') : p("Droit d'usage") }[fam] || fam);
const MODEL_ICON = Object.fromEntries(MODELS.map((m) => [m.id, m.icon]));
/* Le pictogramme d'une offre : celui de son modèle ; sans modèle, le cube ou l'individu. */
export const iconOf = (o) => MODEL_ICON[o.model] || o.icon
  || (o.family === 'product' || o.equation === 'volume_price' ? 'package' : 'user');

export function OfferIcon({ name, size = 16 }) {
  return (
    <svg className="of-ico" viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {F[name] && <path d={F[name]} fill="currentColor" stroke="none" opacity=".14" />}
      <path d={P[name] || P.tag} />
    </svg>
  );
}

/* Les onglets de nature portent le pictogramme de leur famille (2026-09-08) :
   le cube pour un produit, l'individu pour un service, à côté du mot. Un
   pictogramme SEUL demanderait une infobulle pour dire ce qu'il ouvre. */
/* Trois natures, trois pictogrammes DÉJÀ dans la maison : le cube du produit,
   les silhouettes de la prestation, la flèche cyclique du service. */
const ICONE_NATURE = { product: 'box', labour: 'users', service: 'repeat' };
export function TabNature({ fam, label }) {
  return <span className="of-tab"><OfferIcon name={ICONE_NATURE[fam] || 'users'} size={15} /> {label}</span>;
}
